import { PosicaoFilters } from '../../../../types/estoque'

export const ATRASO_DA_BUSCA_MS = 300

export function filtrosNaHora(draft: PosicaoFilters, patch: Partial<PosicaoFilters>): { draft: PosicaoFilters; applied: PosicaoFilters } {
  const proximo = { ...draft, ...patch }
  return { draft: proximo, applied: { ...proximo, page: 1 } }
}

export function buscaPendente(draft: PosicaoFilters, applied: PosicaoFilters): boolean {
  return (draft.busca ?? '').trim() !== (applied.busca ?? '').trim()
}
